import { render, staticRenderFns } from "./DynamicTabsNav.vue?vue&type=template&id=330eb564&"
import script from "./DynamicTabsNav.vue?vue&type=script&lang=js&"
export * from "./DynamicTabsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy/projects/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330eb564')) {
      api.createRecord('330eb564', component.options)
    } else {
      api.reload('330eb564', component.options)
    }
    module.hot.accept("./DynamicTabsNav.vue?vue&type=template&id=330eb564&", function () {
      api.rerender('330eb564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/DynamicTabsNav.vue"
export default component.exports